import { merge } from "lodash";
import { BaseChartOptions } from "./BaseChartOptions";

export const StackedColumnOptions = merge({}, BaseChartOptions, {
    chart: {
        type: "column",
    },
    yAxis: {
        min: 0,
        title: {
            text: "Quantity",
        },
        stackLabels: {
            enabled: true,
            style: {
                fontWeight: "bold",
                color: "gray",
            },
        },
    },
    legend: {
        align: "right",
        x: -30,
        verticalAlign: "top",
        y: 25,
        floating: true,
        backgroundColor: "white",
        borderColor: "#CCC",
        borderWidth: 1,
        shadow: false,
    },
    plotOptions: {
        column: {
            stacking: "normal",
            dataLabels: {
                enabled: true,
            },
        },
        series: {
            pointInterval: 24 * 3600 * 1000,
        },
    },
    responsive: {
        rules: [
            {
                condition: { maxWidth: 630 },
                chartOptions: {
                    yAxis: {
                        labels: { align: "left", x: 0, y: -2 },
                    },
                },
            },
        ],
    },
});
